import React, { Component } from 'react';
import { TenantService } from 'connection/TenantService';
import { CreateOrganizationRequest, SearchOrganizationRequest } from 'models/request/Index';
import { createOrganization, getPlans, getChannels, getBlipSubsidiaries } from 'services/CeberusApiService';
import { Form, Input, Tooltip, Button, Layout, Icon, Popconfirm, Select, Checkbox, Radio } from 'antd';
import { PushNotification } from 'utils/PushNotification';

const SelectOption = Select.Option;

export class OrganizationComponent extends Component<any> {
    isEnterprise: boolean;
    isTestContract: boolean;
    hubspotdealId: '';
    checkDealId: boolean;
    hubspotCompanyId: '';
    checkCompanyId: boolean;
    existingOrganizationId : '';
    checkBlipSubsidiary: boolean;

    state = {
      isLoading: false,
      plans: [],
      channels: [],
      blipSubsidiaries: [],
      hasOtherContract: false,
      sameClusterDestination: false,
      existingOrganizationId: '',
      isClusterGolden: false,
      isClusterDobermann: false,
      tenantSelected: null,
    }

    async componentDidMount() {
      await this.loadPage();
    }

    componentDidUpdate(_, prevState) {
      const currentTenant = TenantService.getSelectedTenant();
      const prevTenant = prevState.tenantSelected;
      if (
        currentTenant &&
        (!prevTenant || prevTenant.name !== currentTenant.name || prevTenant.cluster !== currentTenant.cluster)
      ) {
        this.setState({ tenantSelected: currentTenant }, () => {
          this.loadPage();
        });
      }
    }

    loadPage = async () : Promise<void> => {
      this.setState({ isLoading: true });
      try {
        const tenantSelected = TenantService.getSelectedTenant();
        this.setState({
          isClusterGolden: tenantSelected && tenantSelected.cluster === 'Golden',
          isClusterDobermann: tenantSelected && tenantSelected.cluster === 'Dobermann',
        });
        var request = new SearchOrganizationRequest();
        request.ClusterName = tenantSelected && tenantSelected.name ? tenantSelected.name : '';
        const plans = await getPlans(request);
        const channels = await getChannels();
        
        const blipSubsidiaries = await getBlipSubsidiaries();

        this.setState({ plans, channels, blipSubsidiaries });

      } catch (error) {
        PushNotification.httpError(error);
      }finally{
        this.setState({ isLoading: false });
      }
    }

    handleOnCreateTenant = async (error: any, requestBody: CreateOrganizationRequest) : Promise<void> => {
      const { form } = this.props;

      if (error) {
        this.setState({ isLoading: false });
        PushNotification.error('Some fields are invalid, check values and try again');
        return;
      }

      if (this.hubspotdealId === '' || this.hubspotCompanyId === '') {
        requestBody.DealId = this.hubspotdealId;
        requestBody.HubspotCompanyId = this.hubspotCompanyId;
      }
    
      this.setState({ isLoading: true });
    
      try {
    
        if(requestBody.AdditionalAdminAccount){
          const admin_account_list = requestBody.AdditionalAdminAccount.toString().split(';');
          requestBody.AdditionalAdminAccount = admin_account_list;
        }

        const tenantSelected = TenantService.getSelectedTenant();
        
        requestBody.ClusterName = tenantSelected.name;
        requestBody.IsGolden = this.state.isClusterGolden;
        requestBody.ExistingOrganizationId = this.state.existingOrganizationId;
    
        const response = await createOrganization(requestBody);

        PushNotification.success(response);

        form.resetFields();

        this.checkDealId = false;
        this.checkCompanyId = false;
      } catch (httpError) {
        PushNotification.httpError(httpError);
      }
    
      this.setState({ isLoading: false });
    }
    
    handleIsTestContract = (event: any) : void => {
      const checked = event.target.checked;
      this.isTestContract = checked;
      this.checkDealId = checked;
      this.checkCompanyId = checked;
      this.checkBlipSubsidiary = checked;
    }
    
    handleOnBlurDealId = (event: any) : void => {
      this.hubspotdealId = event.target.value.trim();
    }
    
    handleOnBlurCompanyId= (event: any) : void => {
      this.hubspotCompanyId = event.target.value.trim();
    }

    handleHasOtherContractChange = (event: any): void => {
      const hasOtherContract = event.target.value === 'yes';
      this.setState({ hasOtherContract });
    
      if (!hasOtherContract) {
        this.setState({ sameClusterDestination: false, existingOrganizationId: '' });
        this.props.form.setFieldsValue({ ExistingOrganizationId: '' });
      }
    };
    
    handleSameClusterDestinationChange = (event: any): void => {
      const sameClusterDestination = event.target.value === 'yes';
      this.setState({ sameClusterDestination });
    
      if (!sameClusterDestination) {
        this.setState({ existingOrganizationId: '' });
        this.props.form.setFieldsValue({ ExistingOrganizationId: '' });
      }
    };

    handleExistingOrganizationIdChange = (event: any) : void => {
      this.setState({ existingOrganizationId: event.target.value.trim() });
    }
    
    handleSubmit = (event: any) : void => {
      const { form } = this.props;
      this.setState({ isLoading: true });
      event.preventDefault();
      form.validateFields(this.handleOnCreateTenant);
    }
    
    handleOnSelectedPlan = (plan: string): void => {
      const selectedPlanObject = this.state.plans.find(p => p.name === plan);
      if (
        selectedPlanObject &&
        selectedPlanObject.extras &&
        typeof selectedPlanObject.extras.Cluster === 'string'
      ) {
        this.isEnterprise = selectedPlanObject.extras.Cluster.toLowerCase() === "enterprise";
      } else {
        this.isEnterprise = false;
      }
    }
    
    render() {
      
      const { form } = this.props
      const { getFieldDecorator } = form

      return (
        <div className="flex flex-wrap">
          <div className="tc w-100">
            <h1>Create organization</h1>
            <Layout.Content style={{ width: 400, margin: '0 auto' }}>
              <Form>
                <Form.Item label="Organization id">
                  {getFieldDecorator('OrganizationId', {
                    rules: [
                      {
                        required: true,
                        message: 'You need to fill organization id with 2 - 30 lowercase letters.',
                        pattern: '^[a-z][a-z0-9-]{1,29}$'
                      },
                      {
                        validator: (_, value, callback) => {
                          if (/^com[1-9]$/.test(value)) {
                            callback("Organization id cannot be 'com + number'");
                          } else {
                            callback();
                          }
                      }
                    }
                  ]
                })(<Input />)}
                </Form.Item>
                <Form.Item label="Organization name">
                  {getFieldDecorator('OrganizationName', {
                    rules: [
                      {
                        required: true,
                        message: 'You need to fill organization name'
                      }
                    ]
                  })(<Input />)}
                </Form.Item>
                <Form.Item label="Owner identity">
                  {getFieldDecorator('OwnerIdentity', {
                    rules: [
                      {
                        required: true,
                        message: 'You need to fill owner identity'
                      }
                    ]
                  })(<Input />)}
                </Form.Item>
                <Form.Item
                  label={<span>Additional admin account&nbsp;
                    <Tooltip title="This field is optional. You need to fill in this field with a valid email address.
                    To include more than one, enter the desired account followed by the character ';'">
                      <Icon type="question-circle-o" />
                    </Tooltip>
                  </span>}>
                  {getFieldDecorator('AdditionalAdminAccount', {
                    rules: [
                      {
                        required: false,
                        message: 'Enter a valid e-mail address followed by the character ; (in case you want to inform more than one)',
                        pattern: '^[a-z](([a-z][a-z0-9._-]+)@([a-z][a-z0-9._-]+[a-z0-9]))?;?(([a-z][a-z0-9._-]+)@([a-z][a-z0-9._-]+[a-z0-9]))$'
                      }
                    ]
                  })(<Input />)}
                </Form.Item>
                <Form.Item label='Plan'>
                  {getFieldDecorator('Plan', {
                    rules: [{ required: true }]
                  })(
                    <Select placeholder="Select a plan" onChange={this.handleOnSelectedPlan}>
                      {this.state.plans &&
                        this.state.plans.map(plan => (
                          <SelectOption key={plan.name}>{plan.name}</SelectOption>
                        ))}
                    </Select>
                  )}
                </Form.Item>
                {
                  this.isEnterprise ? 
                    <>
                      <Form.Item label="Channels">
                        {getFieldDecorator('Channels', {
                          rules: [{ required: true }]
                        })(
                          <Select 
                            tokenSeparators={[',', ';', ' ']}
                            mode="tags"
                            placeholder="Select the Channels">
                            {this.state.channels &&
                                this.state.channels.map(channel => (
                                  <SelectOption key={channel}>{channel}</SelectOption>
                                ))}
                          </Select>   
                        )}
                      </Form.Item>
    
                      <Form.Item label="Message volume per month">
                        {getFieldDecorator('VolumeOfMessages', {
                          rules: [{ required: false }] })(<Input />)}
                      </Form.Item>
                    </> : <></>
                }
                <Form.Item label="Organization test" >
                  {getFieldDecorator('IsOrganizationTest', {
                    defaultChecked: false,
                    rules: [
                      {
                        required: false,
                        message: 'You need to fill test'
                      }
                    ],
                    valuePropName:'checked'
                  })(<Checkbox value={this.isTestContract} onChange={this.handleIsTestContract} />)}
                </Form.Item>
                <Form.Item label="Hubspot CompanyId" >
                  {getFieldDecorator('HubspotCompanyId', {
                    rules: [
                      {
                        required: !this.checkCompanyId,
                        message: 'You need to fill CompanyId'
                      }
                    ]
                  })(<Input onBlur={this.handleOnBlurCompanyId} disabled={this.checkCompanyId} />)}
                </Form.Item>
                <Form.Item label="DealId" >
                  {getFieldDecorator('DealId', {
                    rules: [
                      {
                        required: !this.checkDealId,
                        message: 'You need to DealId'
                      }
                    ]
                  })(<Input onBlur={this.handleOnBlurDealId} disabled ={this.checkDealId} />)}
                </Form.Item>
                <Form.Item label='Blip Subsidiary'>
                  {getFieldDecorator('BlipSubsidiary', {
                    rules: [
                      { required: !this.checkBlipSubsidiary, message: 'You need to select a Blip Subsidiary' }
                    ],
                    initialValue:
                      (this.state.isClusterGolden || this.state.isClusterDobermann)
                        ? (this.state.blipSubsidiaries.find(blip => blip === 'Gus') || 'Gus')
                        : (this.state.blipSubsidiaries.find(blip => blip === 'Curupira') || 'Curupira')
                  })(
                    <Select placeholder="Blip Subsidiary" disabled={this.checkBlipSubsidiary}>
                      {this.state.blipSubsidiaries &&
                        this.state.blipSubsidiaries.map(blipSubsidiary => (
                          <SelectOption key={blipSubsidiary}>{blipSubsidiary}</SelectOption>
                        ))}
                    </Select>
                  )}
                </Form.Item>

                <Form.Item label="Client already has another contract?">
                  {getFieldDecorator('HasOtherContract', {
                    initialValue: 'no',
                    rules: [{ required: true }]
                  })(
                    <Radio.Group onChange={this.handleHasOtherContractChange}>
                      <Radio value="yes">Yes</Radio>
                      <Radio value="no">No</Radio>
                    </Radio.Group>
                  )}
                </Form.Item>

                {this.state.hasOtherContract && (
                  <Form.Item label="You want to clusterization in the same cluster as the existing contract?">
                    {getFieldDecorator('SameClusterDestination', {
                      initialValue: 'no',
                      rules: [{ required: true }]
                    })(
                      <Radio.Group onChange={this.handleSameClusterDestinationChange}>
                        <Radio value="yes">Yes</Radio>
                        <Radio value="no">No</Radio>
                      </Radio.Group>
                    )}
                  </Form.Item>
                )}

                {this.state.hasOtherContract && this.state.sameClusterDestination && (
                  <Form.Item label="Existing Organization Id">
                    {getFieldDecorator('ExistingOrganizationId', {
                      rules: [
                        {
                          required: this.state.hasOtherContract && this.state.sameClusterDestination,
                          message: 'You need to fill the Existing Organization Id'
                        }
                      ]
                    })(<Input onBlur={this.handleExistingOrganizationIdChange} />)}
                  </Form.Item>
                )}

                <Form.Item>
                  <Popconfirm
                    title="This action is IRREVERSIBLE. Are you sure?"
                    onConfirm={this.handleSubmit}
                  >
                    <Button type="primary" loading={this.state.isLoading} htmlType="button" >
                      <Icon type="plus-circle" /> Create organization
                    </Button>
                  </Popconfirm>
                </Form.Item>
              </Form>
            </Layout.Content>
          </div>
        </div>
      )
    }
}

export const CreateOrganization = Form.create({ name: 'organization-form' })(
  OrganizationComponent
)